import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { Helmet } from "react-helmet-async";
import { Col, Row } from "reactstrap";

var ps;

function Contacto(props) {
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Contacto</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <div>
            <DemoNavbar {...props} hideTitle />
            <Row>
              <Col xs={12} sm={6} md={5} xl={5} className="p-0 fondoColumna">
                <div className="linea1 helpHeaderLine">
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-center flex-column align-items-center p-2">
                        <h1 className="p-0 m-0 h4 font-weight-bold">
                          CONTACTO
                        </h1>
                        <p className="p-0 m-0 text-light h6">
                          ATENCION AL CLIENTE
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="p-5">
                  <p className="font-weight-bold mb-3">
                    Ponte en contacto con nosotros
                  </p>
                  <p>
                    Si necesita resolver alguna duda o ampliar informacion,
                    nuestro equipo estara encantado de atenderle por telefono o
                    por correo electronico dentro de nuestro horario habitual.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={7} xl={7} className="p-0">
                <div className="linea1 helpHeaderLine d-none d-sm-block"></div>
                <div className="p-5">
                  <div className="colorGrayLigth p-4">
                    <div className="d-flex align-items-center borderModify p-3 mb-3 bg-white">
                      <span className="mdi mdi-phone h4 m-0 mr-3 textColorOrange"></span>
                      <div>
                        <p className="font-weight-bold">Telefono</p>
                        <a href="tel:953900009">953 900 009</a>
                      </div>
                    </div>
                    <div className="d-flex align-items-center borderModify p-3 mb-3 bg-white">
                      <span className="mdi mdi-email h4 m-0 mr-3 textColorOrange"></span>
                      <div>
                        <p className="font-weight-bold">Email</p>
                        <a href="mailto:info@avantsolar.com">
                          info@avantsolar.com
                        </a>
                      </div>
                    </div>
                    <div className="d-flex align-items-center borderModify p-3 bg-white">
                      <span className="mdi mdi-clock-outline h4 m-0 mr-3 textColorOrange"></span>
                      <div>
                        <p className="font-weight-bold">Horario</p>
                        <p>De 08:00 a 17:30</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contacto;
